module.exports = __webpack_public_path__ + "img/alarm-clock.3a3b23fa.svg";